import { URLKeys } from 'noddi-async';
import { useBookingCars, useBookingTimeWindow } from '../bookingStore';

export const useGetConfirmBookingMutationKey = () => {
  const cars = useBookingCars();
  const selectedTimeWindow = useBookingTimeWindow();
  return [URLKeys.postCreateBooking, cars, selectedTimeWindow];
};
